import { Text } from '@musa.tech/design-system';

export const IAHeader = () => (
  <div>
    <Text variant="heading" className="text-2xl md:text-3xl font-bold text-foreground">
      Indicadores Ambientais
    </Text>
    <Text variant="body" className="text-sm md:text-base text-muted-foreground mt-1">
      Acompanhe o impacto positivo da sua empresa no meio ambiente
    </Text>
  </div>
);
